// Reading the server's refusal of a Mark Done undo (#535). Pure, so the workspace can say what
// happened instead of showing a raw error.
import { ApiError, REQUEST_DONE_UNDO_CONFLICT, type UndoDoneRefusal } from "@/api";

/**
 * The refusal reason when the server declined an undo, else null. A refusal is never a failure to
 * retry: every reason means the request is no longer the one that was marked done.
 */
export function undoDoneRefusal(error: unknown): UndoDoneRefusal | null {
  if (!(error instanceof ApiError) || error.status !== 409) return null;
  const data = error.data as Record<string, unknown> | null;
  if (data?.code !== REQUEST_DONE_UNDO_CONFLICT) return null;
  const reason = data.reason;
  return reason === "not_done"
    || reason === "archived"
    || reason === "version_mismatch"
    || reason === "missing_prior_state"
    ? reason
    : null;
}

/** The i18n key explaining a refusal to the operator. */
export function undoDoneRefusalKey(reason: UndoDoneRefusal): string {
  return reason === "archived" ? "ws.undoDoneArchived" : "ws.undoDoneStale";
}
